import React  from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getGroupComparisonStatistics } from './queries/queries';
import GroupComparisonWidget from '../../common/widgets/groupComparison';
import DataProcessor from '../../common/dataProcessors/groupComparisonDataProcessor';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class GroupComparison extends BaseWidget {
  get statisticsData() {
    return { groups: this.props.data.statistics.churchManager.church.daily.groupComparison };
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'day');
  }

  render() {
    return (
      <GroupComparisonWidget title="Daily Group Comparison" data={this.dataProcessor.data}
                             chartData={this.dataProcessor.chartData} loading={this.props.data.loading}
                             comment={this.comment}/>
    );
  }
}

export default compose(
  graphql(getGroupComparisonStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(GroupComparison);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/daily/groupComparison.js